(() => {
  const getCollectionRoot = () => document.querySelector('[data-section-type="collection-template"]');

  const ensureBestSellingDefault = () => {
    const root = getCollectionRoot();
    if (!root || root.dataset.iineDefaultBestSelling !== 'true') return false;
    if (window.Shopify && window.Shopify.designMode) return false;

    const url = new URL(window.location.href);
    if (url.searchParams.has('sort_by')) return false;

    url.searchParams.set('sort_by', 'best-selling');
    window.location.replace(url.toString());
    return true;
  };

  const centerActiveCategory = () => {
    const rail = document.querySelector('[data-iine-category-scroll]');
    const active = rail && rail.querySelector('.is-active');
    if (!rail || !active || rail.scrollWidth <= rail.clientWidth) return;

    if (active === rail.firstElementChild) {
      rail.scrollLeft = 0;
      return;
    }

    const target = active.offsetLeft - ((rail.clientWidth - active.offsetWidth) / 2);
    rail.scrollLeft = Math.max(0, target);
  };

  document.addEventListener('change', (event) => {
    const select = event.target.closest('[data-iine-collection-sort]');
    if (!select) return;

    const root = getCollectionRoot();
    const filterForm = root && root.querySelector('#CollectionFilterForm');
    if (!filterForm) return;

    const radios = filterForm.querySelectorAll('input[name="sort_by"]');
    const selectedRadio = Array.from(radios).find((radio) => radio.value === select.value);
    if (!selectedRadio) return;

    selectedRadio.checked = true;
    selectedRadio.dispatchEvent(new Event('change', { bubbles: true }));
  });

  const init = () => {
    if (ensureBestSellingDefault()) return;
    requestAnimationFrame(centerActiveCategory);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
